/* eslint-disable */
import {
  postConexion,
  putConexion,
  getConexion,
  getConexionHeaders,
  deleteConexion
} from '../../conexion/Conexion';

/* prettier-ignore */
export const getAllUsersByBusinessId = () => async (objUser: any): Promise<any> => {
  const users = await postConexion('users/getUsersByBusinessId', objUser);

  return users;
};

export const updateBusiness = async (objUser: any): Promise<any> => {
  await putConexion('cash/business', objUser);
};

export const disableBusiness = async (objUser: any): Promise<any> => {
  await postConexion('cash/disableBusiness', objUser);
};

export const setCashOportunity = async (obj: any): Promise<any> => {
  await postConexion('cash/saveCostoOportunidad', obj);
};

export const setPerformance = async (obj: any): Promise<any> => {
  await postConexion('cash/saveTasaRendimiento', obj);
};

export const getCashOportunity = async (): Promise<any> => {
  // const obj = {
  //   accessToken
  // };
  const cost = await getConexion('cash/getLastCostoOportunidad');
  return cost;
};

export const saveTransCost = async (obj: any): Promise<any> => {
  const value = {
    valor: obj,
  };
  await postConexion('cash/saveTransCost', value);
};

export const saveMinCash = async (obj: any): Promise<any> => {
  const value = {
    valor: obj,
  };
  await postConexion('cash/saveMinCash', value);
};

export const getTarProm = async (obj: any): Promise<any> => {
  const info = await getConexionHeaders(
    'cash/getTarProm',
    `?businessId=${obj}`
  );
  return info;
};

export const saveContract = async (obj: any): Promise<any> => {
  const value = {
    detail: obj,
  };
  await postConexion('cash/saveClientContract', value);
};

export const updateFlagContract = async (obj: any): Promise<any> => {
  await putConexion('cash/business', obj);
};

export const getZazacorpPrediction = async (fecha: any,fechaHasta: any, tabla:any): Promise<any> => {
  console.log('fecha: ', fecha);
  console.log('fechaHasta: ', fechaHasta);
  return await getConexion(`cash/zazacorpPrediction/${fecha}/${fechaHasta}/${tabla}`);
};

export const deleteLoan = async (id: any): Promise<any> => {
  console.log('id: ', id);
  return await getConexion(`cash/deleteLoan/${id}`);
};